import { useMemo } from 'react';
import { MapChartData, MapDataMapping, MapPointDatum, MapRegionDatum } from '../config/mapChartTypes';

export const useMapData = (
    data: any[],
    mapping: MapDataMapping
): MapChartData => {
    return useMemo(() => {
        if (!data || !Array.isArray(data)) return {};

        const points: MapPointDatum[] = [];
        const regions: MapRegionDatum[] = [];

        data.forEach((d) => {
            // Point Data Processing
            if (mapping.latitudeField && mapping.longitudeField) {
                const lat = Number(d[mapping.latitudeField]);
                const lon = Number(d[mapping.longitudeField]);

                if (!isNaN(lat) && !isNaN(lon)) {
                    points.push({
                        lat,
                        lon,
                        label: mapping.categoryField ? d[mapping.categoryField] : undefined,
                        value: mapping.valueField ? Number(d[mapping.valueField]) : undefined,
                        category: mapping.categoryField ? d[mapping.categoryField] : undefined,
                        ...d // Keep original data for tooltips
                    });
                }
            }

            // Region Data Processing
            if (mapping.regionKeyField && d[mapping.regionKeyField]) {
                regions.push({
                    regionKey: String(d[mapping.regionKeyField]),
                    label: mapping.categoryField ? d[mapping.categoryField] : d[mapping.regionKeyField],
                    value: mapping.valueField ? Number(d[mapping.valueField]) : undefined,
                    category: mapping.categoryField ? d[mapping.categoryField] : undefined,
                    ...d
                });
            }
        });

        return { points, regions };
    }, [data, mapping]);
};
